import { Download, Send } from 'lucide-react';
import { PdfPreviewDialog } from '../PdfPreviewDialog/PdfPreviewDialog';

export function BOLPreviewDialog({
  url,
  loadNumber,
  hasUnsavedChanges,
  onClose,
  onDownload,
  onSend,
}: {
  url: string;
  loadNumber?: string | null;
  hasUnsavedChanges?: boolean;
  onClose: () => void;
  onDownload: () => void;
  onSend: () => void;
}) {
  return (
    <PdfPreviewDialog
      url={url}
      title={`BOL Preview${loadNumber ? ` · Load ${loadNumber}` : ''}`}
      onClose={onClose}
      notice={
        hasUnsavedChanges ? (
          <div className="error-box error-box--spaced">
            You have unsaved changes. This preview reflects the last saved version. Click Update
            first to see them.
          </div>
        ) : null
      }
      footer={
        <div className="actions">
          <button className="btn btn--secondary" onClick={onDownload}>
            <Download size={14} /> Download
          </button>
          <button className="btn btn--primary" onClick={onSend}>
            <Send size={14} /> Send BOL
          </button>
        </div>
      }
    />
  );
}
